export default function random() {
  return Math.random();
}
